
import {MystHarpon} from './app/MystHarpon.js';
window.MystHarpon = MystHarpon;
